module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido-4fe49c0e2f944d6ffef4fd46b12ccc59.jpg";